module.exports = __webpack_public_path__ + "static/media/InactiveHeart.b081eec5.svg";